// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { useTranslation } from 'react-i18next';
import styles from './kanjiSuggestion.module.css';
import { getKanjiSuggestionsFromHiragana } from '../../utils/suggestionsEngine';

function KanjiSuggestion(props) {
    const { t } = useTranslation('common');
    const suggestions = getKanjiSuggestionsFromHiragana(props.word);

    const handleCancel = (e) => {
        props.cancelHandler();
    }

    return (
        <div className={styles.container}>
            <div>
                <span className={styles.label}>{t("kanjiSuggestion.yourWord")}</span>
            </div>
            <div>
                <button onClick={() => props.selectedWordHandler(props.word)}>
                    {props.word}
                </button>
            </div>
            <div className={styles.kanji}>
                <div>
                    <span className={styles.label}>{t("kanjiSuggestion.suggestions")}</span>
                </div>
                {suggestions.map(function (item, i) {
                    return <button key={item.Kanji} onClick={() => props.selectedWordHandler(item.Kanji)}>
                        <>
                            {item.Kanji}
                            <div>
                                {item.Meanings.map(function (meaning, k) {
                                    return t(`kanjiSuggestion.meanings.${meaning}`, { defaultValue: meaning }) + " ";
                                })}
                            </div>
                        </>
                    </button>;
                })}
            </div>
            <div>
                <button className={styles.cancel} onClick={handleCancel}>
                    {t("kanjiSuggestion.cancel")}
                </button>
            </div>
        </div>
    );
}

export default KanjiSuggestion;
